var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('q-score-card',{key:"QScoreCardNewWriters",ref:"card",attrs:{"title":"New Writers","api-endpoint":"new_writers","drill-down-label":"New Writers","drill-down-route":"Drilldown_NewWriters","card-style":"recruiting","agent-code":_vm.agentCode,"filters":_vm.filters},on:{"most_current":_vm.updateMostCurrent}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }